import React, { useMemo } from 'react';
import { useListOrderTagsQuery } from '../../../../API/order/tags/OrderTagApi';
import { SimpleGrid } from '../../../../tailwindComponents/grid/SimpleGrid';
import { Show } from '../../../shared/Show';
import { OrderTagItem } from './OrderTagItem';
import { SpinnerTW } from '../../../../tailwindComponents/spinnerTW/SpinnerTW';
import { ErrorMessageTW } from '../../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { IHasTestData } from '../../../../ui-toolkit/test-utilities/IHasTestData';
import { sortTagsAlphabeticallyByType } from '../../../../utilities/order/tags/sortTagsAlphabeticallyByType';
import { mergeTests } from '../../../../ui-toolkit/test-utilities/mergeTests';

export interface ListContainerProps extends IHasTestData {
  orderId: string;
}

export const ListContainer: React.FC<ListContainerProps> = ({ orderId, ...rest }) => {
  const { data: tags = [], isFetching: isTagsFetching, error } = useListOrderTagsQuery(orderId);

  const sortedTags = useMemo(() => [...tags].sort(sortTagsAlphabeticallyByType), [tags]);
  return (
    <>
      <ErrorMessageTW rtkError={error} />
      <Show when={!isTagsFetching} fallback={<SpinnerTW />}>
        <SimpleGrid
          className={'divide-y divide-solid divide-gray-200 py-6'}
          data-test-id={mergeTests(rest['data-test-id'], 'order-tag-list-container')}
          data-test-class={mergeTests(rest['data-test-id'], 'order-tag-list-container')}
        >
          {sortedTags.map((orderTag) => (
            <OrderTagItem key={orderTag.tag.id} orderTag={orderTag} />
          ))}
        </SimpleGrid>
      </Show>
    </>
  );
};
